// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"796ac1af","498":"29982faa","703":"5095a5aa","787":"abfdb197"}[chunkId] + ".chunk.js";
};